export default "__VITE_ASSET__BUxEy97O__"